/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.CallEventOptMsg = (function() {

    /**
     * Properties of a CallEventOptMsg.
     * @exports ICallEventOptMsg
     * @interface ICallEventOptMsg
     * @property {string|null} [guid] CallEventOptMsg guid
     * @property {number|null} [version] CallEventOptMsg version
     * @property {string|null} [refGuid] CallEventOptMsg refGuid
     * @property {CallEventOptMsg.OptFrom|null} [optFrom] CallEventOptMsg optFrom
     * @property {CallEventOptMsg.CallOpt|null} [opt] CallEventOptMsg opt
     * @property {string|null} [fromGuid] CallEventOptMsg fromGuid
     * @property {string|null} [toGuid] CallEventOptMsg toGuid
     * @property {number|Long|null} [time] CallEventOptMsg time
     */

    /**
     * Constructs a new CallEventOptMsg.
     * @exports CallEventOptMsg
     * @classdesc Represents a CallEventOptMsg.
     * @implements ICallEventOptMsg
     * @constructor
     * @param {ICallEventOptMsg=} [properties] Properties to set
     */
    function CallEventOptMsg(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CallEventOptMsg guid.
     * @member {string} guid
     * @memberof CallEventOptMsg
     * @instance
     */
    CallEventOptMsg.prototype.guid = "";

    /**
     * CallEventOptMsg version.
     * @member {number} version
     * @memberof CallEventOptMsg
     * @instance
     */
    CallEventOptMsg.prototype.version = 0;

    /**
     * CallEventOptMsg refGuid.
     * @member {string} refGuid
     * @memberof CallEventOptMsg
     * @instance
     */
    CallEventOptMsg.prototype.refGuid = "";

    /**
     * CallEventOptMsg optFrom.
     * @member {CallEventOptMsg.OptFrom} optFrom
     * @memberof CallEventOptMsg
     * @instance
     */
    CallEventOptMsg.prototype.optFrom = 0;

    /**
     * CallEventOptMsg opt.
     * @member {CallEventOptMsg.CallOpt} opt
     * @memberof CallEventOptMsg
     * @instance
     */
    CallEventOptMsg.prototype.opt = 0;

    /**
     * CallEventOptMsg fromGuid.
     * @member {string} fromGuid
     * @memberof CallEventOptMsg
     * @instance
     */
    CallEventOptMsg.prototype.fromGuid = "";

    /**
     * CallEventOptMsg toGuid.
     * @member {string} toGuid
     * @memberof CallEventOptMsg
     * @instance
     */
    CallEventOptMsg.prototype.toGuid = "";

    /**
     * CallEventOptMsg time.
     * @member {number|Long} time
     * @memberof CallEventOptMsg
     * @instance
     */
    CallEventOptMsg.prototype.time = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * Creates a new CallEventOptMsg instance using the specified properties.
     * @function create
     * @memberof CallEventOptMsg
     * @static
     * @param {ICallEventOptMsg=} [properties] Properties to set
     * @returns {CallEventOptMsg} CallEventOptMsg instance
     */
    CallEventOptMsg.create = function create(properties) {
        return new CallEventOptMsg(properties);
    };

    /**
     * Encodes the specified CallEventOptMsg message. Does not implicitly {@link CallEventOptMsg.verify|verify} messages.
     * @function encode
     * @memberof CallEventOptMsg
     * @static
     * @param {ICallEventOptMsg} message CallEventOptMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CallEventOptMsg.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.guid != null && message.hasOwnProperty("guid"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.guid);
        if (message.version != null && message.hasOwnProperty("version"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.version);
        if (message.refGuid != null && message.hasOwnProperty("refGuid"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.refGuid);
        if (message.optFrom != null && message.hasOwnProperty("optFrom"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.optFrom);
        if (message.opt != null && message.hasOwnProperty("opt"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.opt);
        if (message.fromGuid != null && message.hasOwnProperty("fromGuid"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.fromGuid);
        if (message.toGuid != null && message.hasOwnProperty("toGuid"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.toGuid);
        if (message.time != null && message.hasOwnProperty("time"))
            writer.uint32(/* id 8, wireType 0 =*/64).int64(message.time);
        return writer;
    };

    /**
     * Encodes the specified CallEventOptMsg message, length delimited. Does not implicitly {@link CallEventOptMsg.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CallEventOptMsg
     * @static
     * @param {ICallEventOptMsg} message CallEventOptMsg message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CallEventOptMsg.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CallEventOptMsg message from the specified reader or buffer.
     * @function decode
     * @memberof CallEventOptMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CallEventOptMsg} CallEventOptMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CallEventOptMsg.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CallEventOptMsg();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.guid = reader.string();
                break;
            case 2:
                message.version = reader.int32();
                break;
            case 3:
                message.refGuid = reader.string();
                break;
            case 4:
                message.optFrom = reader.int32();
                break;
            case 5:
                message.opt = reader.int32();
                break;
            case 6:
                message.fromGuid = reader.string();
                break;
            case 7:
                message.toGuid = reader.string();
                break;
            case 8:
                message.time = reader.int64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CallEventOptMsg message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CallEventOptMsg
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CallEventOptMsg} CallEventOptMsg
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CallEventOptMsg.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CallEventOptMsg message.
     * @function verify
     * @memberof CallEventOptMsg
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CallEventOptMsg.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.guid != null && message.hasOwnProperty("guid"))
            if (!$util.isString(message.guid))
                return "guid: string expected";
        if (message.version != null && message.hasOwnProperty("version"))
            if (!$util.isInteger(message.version))
                return "version: integer expected";
        if (message.refGuid != null && message.hasOwnProperty("refGuid"))
            if (!$util.isString(message.refGuid))
                return "refGuid: string expected";
        if (message.optFrom != null && message.hasOwnProperty("optFrom"))
            switch (message.optFrom) {
            default:
                return "optFrom: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.opt != null && message.hasOwnProperty("opt"))
            switch (message.opt) {
            default:
                return "opt: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.fromGuid != null && message.hasOwnProperty("fromGuid"))
            if (!$util.isString(message.fromGuid))
                return "fromGuid: string expected";
        if (message.toGuid != null && message.hasOwnProperty("toGuid"))
            if (!$util.isString(message.toGuid))
                return "toGuid: string expected";
        if (message.time != null && message.hasOwnProperty("time"))
            if (!$util.isInteger(message.time) && !(message.time && $util.isInteger(message.time.low) && $util.isInteger(message.time.high)))
                return "time: integer|Long expected";
        return null;
    };

    /**
     * Creates a CallEventOptMsg message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CallEventOptMsg
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CallEventOptMsg} CallEventOptMsg
     */
    CallEventOptMsg.fromObject = function fromObject(object) {
        if (object instanceof $root.CallEventOptMsg)
            return object;
        var message = new $root.CallEventOptMsg();
        if (object.guid != null)
            message.guid = String(object.guid);
        if (object.version != null)
            message.version = object.version | 0;
        if (object.refGuid != null)
            message.refGuid = String(object.refGuid);
        switch (object.optFrom) {
        case "FROM":
        case 0:
            message.optFrom = 0;
            break;
        case "CLIENT":
        case 1:
            message.optFrom = 1;
            break;
        }
        switch (object.opt) {
        case "ALLOW":
        case 0:
            message.opt = 0;
            break;
        case "REJECT":
        case 1:
            message.opt = 1;
            break;
        }
        if (object.fromGuid != null)
            message.fromGuid = String(object.fromGuid);
        if (object.toGuid != null)
            message.toGuid = String(object.toGuid);
        if (object.time != null)
            if ($util.Long)
                (message.time = $util.Long.fromValue(object.time)).unsigned = false;
            else if (typeof object.time === "string")
                message.time = parseInt(object.time, 10);
            else if (typeof object.time === "number")
                message.time = object.time;
            else if (typeof object.time === "object")
                message.time = new $util.LongBits(object.time.low >>> 0, object.time.high >>> 0).toNumber();
        return message;
    };

    /**
     * Creates a plain object from a CallEventOptMsg message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CallEventOptMsg
     * @static
     * @param {CallEventOptMsg} message CallEventOptMsg
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CallEventOptMsg.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.guid = "";
            object.version = 0;
            object.refGuid = "";
            object.optFrom = options.enums === String ? "FROM" : 0;
            object.opt = options.enums === String ? "ALLOW" : 0;
            object.fromGuid = "";
            object.toGuid = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.time = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.time = options.longs === String ? "0" : 0;
        }
        if (message.guid != null && message.hasOwnProperty("guid"))
            object.guid = message.guid;
        if (message.version != null && message.hasOwnProperty("version"))
            object.version = message.version;
        if (message.refGuid != null && message.hasOwnProperty("refGuid"))
            object.refGuid = message.refGuid;
        if (message.optFrom != null && message.hasOwnProperty("optFrom"))
            object.optFrom = options.enums === String ? $root.CallEventOptMsg.OptFrom[message.optFrom] : message.optFrom;
        if (message.opt != null && message.hasOwnProperty("opt"))
            object.opt = options.enums === String ? $root.CallEventOptMsg.CallOpt[message.opt] : message.opt;
        if (message.fromGuid != null && message.hasOwnProperty("fromGuid"))
            object.fromGuid = message.fromGuid;
        if (message.toGuid != null && message.hasOwnProperty("toGuid"))
            object.toGuid = message.toGuid;
        if (message.time != null && message.hasOwnProperty("time"))
            if (typeof message.time === "number")
                object.time = options.longs === String ? String(message.time) : message.time;
            else
                object.time = options.longs === String ? $util.Long.prototype.toString.call(message.time) : options.longs === Number ? new $util.LongBits(message.time.low >>> 0, message.time.high >>> 0).toNumber() : message.time;
        return object;
    };

    /**
     * Converts this CallEventOptMsg to JSON.
     * @function toJSON
     * @memberof CallEventOptMsg
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CallEventOptMsg.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    /**
     * OptFrom enum.
     * @name CallEventOptMsg.OptFrom
     * @enum {string}
     * @property {number} FROM=0 FROM value
     * @property {number} CLIENT=1 CLIENT value
     */
    CallEventOptMsg.OptFrom = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "FROM"] = 0;
        values[valuesById[1] = "CLIENT"] = 1;
        return values;
    })();

    /**
     * CallOpt enum.
     * @name CallEventOptMsg.CallOpt
     * @enum {string}
     * @property {number} ALLOW=0 ALLOW value
     * @property {number} REJECT=1 REJECT value
     */
    CallEventOptMsg.CallOpt = (function() {
        var valuesById = {}, values = Object.create(valuesById);
        values[valuesById[0] = "ALLOW"] = 0;
        values[valuesById[1] = "REJECT"] = 1;
        return values;
    })();

    return CallEventOptMsg;
})();

module.exports = $root;
